/* External dependencies */
import * as React from 'react';

/* Local dependencies */
import './src/components/layout/index.css';
import { theme } from './src/components/layout/constants/theme';
import { ThemeContext } from './src/components/layout/styling';
import wrapWithProvider from './src/redux/wrap-with-provider';

const { Provider: ThemeProvider } = ThemeContext;

// Shared by gatsby-ssr (Styletron Server) and gatsby-browser (Styletron Client).
// Must match on both sides or client hydration won't reuse server-rendered atomic classes.
export const STYLETRON_PREFIX = '_';

export function wrapRootElement({ element }) {
  return wrapWithProvider({ element });
}

// React.createElement (not JSX) so the React import stays referenced and can't be
// stripped by eslint — see gatsby-browser.js for why that would break hydration.
export function wrapPageElement({ element }) {
  return React.createElement(ThemeProvider, { value: theme }, element);
}
